const menu = [
  {
    heading: "Learning Management System",
  },
  {
    text: "Master",
    icon: "setting",
    subMenu: [
      {
        text: "Subject",
        icon: "book",
        link: "/master/subject",
      },
      {
        text: "Chapter",
        icon: "book-read",
        link: "/master/chapter",
      },
      {
        text: "Question",
        icon: "question",
        link: "/master/question",
      },
      {
        text: "Session",
        icon: "question",
        link: "/master/session",
      },
    ],
  },
  {
    icon: "dashboard",
    text: "E-Content",
    link: "/e-content",
  },
  {
    icon: "dashboard",
    text: "Test Result",
    link: "/result",
  },
  // {
  //   icon: "img-fill",
  //   text: "Banner",
  //   link: "/manage-banner",
  // },
  // {
  //   icon: "user-group",
  //   text: "VIP Banner",
  //   link: "/vip-banner",
  // },
  // {
  //   icon: "tree-structure-fill",
  //   text: "Manage Menu",
  //   link: "/manage-menu",
  // },
  // {
  //   icon: "user-list-fill",
  //   text: "Management Directory",
  //   link: "/management-directory",
  // },
  // {
  //   icon: "network",
  //   text: "Organizational Structure",
  //   link: "/organizational-structure",
  // },
  // {
  //   icon: "img-fill",
  //   text: "Photo Gallery",
  //   link: "/manage-photo-gallery",
  // },
  // {
  //   icon: "video",
  //   text: "Video Gallery",
  //   link: "/manage-video-gallery",
  // },
  // {
  //   icon: "newspaper",
  //   text: "News / Events & Announcements",
  //   link: "/news",
  // },
  // {
  //   icon: "img-fill",
  //   text: "Image Upload",
  //   link: "/upload-image",
  // },
  // {
  //   icon: "file-text",
  //   text: "Feedback",
  //   link: "/feedback",
  // },
  // {
  //   icon: "question",
  //   text: "FAQ",
  //   link: "/faq",
  // },
];
export default menu;
